import ui from 'styles/ui.module.css';
import styles from './EstadoAsambleaAviso.module.css';

// Franja informativa sobre qué se puede hacer con las preguntas según el estado
// de la asamblea (regla R108). Solo informa; los botones ya se bloquean aparte.
export const MOTIVO_NO_INICIADA = 'La asamblea aún no ha iniciado: iníciala para abrir o cerrar votaciones.';
export const MOTIVO_FINALIZADA  = 'La asamblea ya finalizó: sus preguntas y votaciones son las del acta. Para corregir algo, reábrela.';

// La app no tiene estilo global para botones deshabilitados: esta clase compartida (ui.module.css) los hace ver apagados.
export const CLASE_BLOQUEADO = ui.bloqueado;

export default function EstadoAsambleaAviso({ status }) {
  if (status !== 'pendiente' && status !== 'finalizada') return null;
  const pendiente = status === 'pendiente';
  return (
    <div role="status" className={pendiente ? styles.avisoPendiente : styles.avisoFinalizada}>
      <i className={`fas ${pendiente ? 'fa-circle-info' : 'fa-lock'} ${styles.icono}`} />
      <span>
        {pendiente
          ? <><strong>Esta asamblea aún no ha iniciado.</strong> Puedes preparar las preguntas; las votaciones se abren cuando la inicies.</>
          : <><strong>Esta asamblea ya finalizó.</strong> Sus preguntas son las del acta. Para corregir algo, reábrela.</>}
      </span>
    </div>
  );
}
